module.exports = __webpack_public_path__ + "img/excavating_machinery-icon2.a0da54b3.png";